import type { ItemDefInput } from '../../schemas/items';

/** Minimart surfaces & storage (docs/design/content-items.md §D). Preplaced counts match MINIMART_LAYOUT. */
export const FIXTURES = [
  {
    id: 'fix_checkout_counter',
    kind: 'fixture',
    nameKey: 'item.fix_checkout_counter.name',
    loreKey: 'item.fix_checkout_counter.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 2, h: 1 },
    rotations: 2,
    tags: ['checkout', 'counter'],
    slots: { count: 1, surfaceTag: 'counter', accepts: [{ kinds: ['decor'], layers: ['surface'] }] },
    removable: false,
    material: 'wood',
    sources: [{ kind: 'preplaced', roomId: 'minimart', count: 1 }],
    sprite: { frame: 'item_fix_checkout_counter' },
  },
  {
    id: 'fix_shelf_small',
    kind: 'fixture',
    nameKey: 'item.fix_shelf_small.name',
    loreKey: 'item.fix_shelf_small.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 2, h: 1 },
    rotations: 2,
    tags: ['shelf'],
    unlockId: 'unl_minimart',
    buyPrice: 80,
    slots: { count: 4, surfaceTag: 'shelf', accepts: [{ kinds: ['product'] }] },
    material: 'wood',
    sources: [{ kind: 'catalog' }, { kind: 'preplaced', roomId: 'minimart', count: 2 }],
    sprite: { frame: 'item_fix_shelf_small' },
  },
  {
    id: 'fix_shelf_tall',
    kind: 'fixture',
    nameKey: 'item.fix_shelf_tall.name',
    loreKey: 'item.fix_shelf_tall.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 2, h: 1 },
    rotations: 2,
    tags: ['shelf'],
    unlockId: 'unl_shop_expansion_1',
    buyPrice: 180,
    slots: { count: 8, surfaceTag: 'shelf', accepts: [{ kinds: ['product'] }] },
    material: 'wood',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_fix_shelf_tall' },
  },
  {
    id: 'fix_drink_fridge',
    kind: 'fixture',
    nameKey: 'item.fix_drink_fridge.name',
    loreKey: 'item.fix_drink_fridge.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 2,
    tags: ['fridge'],
    unlockId: 'unl_minimart',
    buyPrice: 150,
    slots: { count: 6, surfaceTag: 'fridge', accepts: [{ kinds: ['product'], categories: ['drink'] }] },
    material: 'glass',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: 'item_fix_drink_fridge' },
  },
  {
    id: 'fix_basket_display',
    kind: 'fixture',
    nameKey: 'item.fix_basket_display.name',
    loreKey: 'item.fix_basket_display.lore',
    shopTab: 'furniture',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 1,
    tags: ['basket'],
    unlockId: 'unl_minimart',
    buyPrice: 60,
    slots: {
      count: 4,
      surfaceTag: 'basket',
      accepts: [{ kinds: ['product'], categories: ['food', 'fruit', 'garden'] }],
    },
    material: 'wood',
    sources: [{ kind: 'catalog' }, { kind: 'preplaced', roomId: 'minimart', count: 1 }],
    sprite: { frame: 'item_fix_basket_display' },
  },
] as const satisfies readonly ItemDefInput[];
